<pmt-action-modal [title]="'know-how.modalTitle' | transloco" [submitButtonText]="'modal.sendButton' | transloco"
    (submitted)="onSubmit()" [onlyCancel]="false" [submitButtonIconCode]="''" class="custom-modal-limiter"
    [isSaving]="isLoading">
    <div class="d-flex flex-column gap-2" [formGroup]="feedbackForm">
        <div>
            <label>{{'shared.emailing.from' | transloco}}</label>
            <div class="m-0">
                <span class="badge bg-secondary" [tooltip]="sender?.email">
                    {{ sender?.givenName }} {{ sender?.familyName }}
                </span>
            </div>
        </div>

        <div *ngIf="admins">
            <label>{{'shared.emailing.to' | transloco}}</label>
            <div class="m-0 d-flex flex-wrap gap-1">
                <div *ngFor="let admin of admins">
                    <span class="badge bg-secondary" [tooltip]="admin.email">
                        {{ admin.firstName }} {{ admin.lastName }}
                    </span>
                </div>
            </div>
        </div>

        <div class="text-align-center">
            <input class="me-2" id="sendCopy" type="checkbox" formControlName="isSendCopy" />
            <label for="sendCopy">{{'shared.emailing.sendCopy' | transloco}}</label>
        </div>

        <div>
            <label for="subject">{{'shared.emailing.subject' | transloco}}</label>
            <input id="subject" type="text" [value]="feedbackSubject" class="form-control" [disabled]="true" />
        </div>

        <div>
            <label for="email">{{'shared.emailing.message' | transloco}}</label>
            <textarea id="email" formControlName="feedback" rows="5" class="form-control" [disabled]="isLoading"
                [placeholder]="'shared.emailing.messagePlaceholder' | transloco"></textarea>
        </div>
    </div>
</pmt-action-modal>